// extracted by mini-css-extract-plugin
export var addButton = "_q3-0";
export var border = "_q3-8";
export var check = "_q3-h";
export var danger = "_q3-6";
export var dropdownContainer = "_q3-1";
export var editModalBody = "_q3-j";
export var footerContainer = "_q3-i";
export var fullWidth = "_q3-a";
export var hide = "_q3-9";
export var icon = "_q3-3";
export var input = "_q3-7";
export var inputFlex = "_q3-b";
export var inputWrapper = "_q3-c";
export var manualFocus = "_q3-5";
export var optionButton = "_q3-4";
export var pillWrapper = "_q3-e";
export var pointer = "_q3-2";
export var showOverflow = "_q3-f";
export var tagsFlex = "_q3-d";
export var xButton = "_q3-g";